import React, { FC } from 'react';

const Thead: FC = ({ children }) => {
  return <thead><tr>{children}</tr></thead>;
};

export default Thead;
